module.exports = __webpack_public_path__ + "img/platina.02c0080a.png";